// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__0Yj5n","titleBlock":"Advt_titleBlock__IIZZh","title":"Advt_title__bttYn","qrCode":"Advt_qrCode__TgG17"};